import getRouterBasename from '@/lib/router';
import { ArrowLeft, Home, type LucideIcon } from 'lucide-react';

interface DashboardErrorPageProps {
    icon: LucideIcon;
    code: string;
    title: string;
    message: string;
}

export function DashboardErrorPage({
    icon: Icon,
    code,
    title,
    message
}: DashboardErrorPageProps) {
    return (
        <div className="flex flex-col justify-center items-center bg-background px-4 w-full h-full min-h-screen">
            <div className="w-full max-w-lg text-center">
                <div className="flex justify-center mb-6">
                    <div className="bg-muted p-4 rounded-full">
                        <Icon
                            className="w-16 h-16 text-muted-foreground"
                            strokeWidth={1.5}
                        />
                    </div>
                </div>
                <p className="mb-2 font-medium text-muted-foreground text-sm">
                    {code}
                </p>
                <h1 className="mb-3 font-semibold text-foreground text-2xl md:text-3xl">
                    {title}
                </h1>
                <p className="mb-8 text-muted-foreground">{message}</p>
                <div className="flex sm:flex-row flex-col justify-center gap-3">
                    <a
                        href={`${getRouterBasename()}/`}
                        className="inline-flex justify-center items-center gap-2 bg-primary hover:bg-foreground/90 px-5 py-2.5 rounded-md font-medium text-primary-foreground text-sm transition-colors"
                    >
                        <Home className="w-4 h-4" />
                        Go to chat
                    </a>
                    <button
                        type="button"
                        onClick={() => window.history.back()}
                        className="inline-flex justify-center items-center gap-2 hover:bg-muted px-5 py-2.5 border border-border rounded-md font-medium text-foreground text-sm transition-colors"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Go back
                    </button>
                </div>
            </div>
        </div>
    );
}
